/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/ZeroData" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Link } from "VSSUI/Link";
import { IZeroDataItem } from "VSSUI/ZeroData";
import { EnterpriseNewConnection, NewConnection } from "Wit/Settings/BoardsExternalIntegration/components/common";
import { isHosted } from "Wit/Settings/BoardsExternalIntegration/components/common/Utilities";
import { IZeroDataProps } from "Wit/Settings/BoardsExternalIntegration/components/ZeroData.Props";
import { ZeroDataItem } from "Wit/Settings/BoardsExternalIntegration/components/ZeroDataItem";
import { DocUrls } from "Wit/Settings/BoardsExternalIntegration/constants/Constants";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";
import { isIE } from "Wit/Settings/BoardsExternalIntegration/utils/BrowserUtil";

export class ZeroData extends VssComponent<IZeroDataProps, {}, IVssComponentContext> {
    public render() {
        const imagePath = getAssetLocation(
            this.context.pageContext,
            "ms.vss-work-web/boards-external-integration-content/assets/boards_external_integration_zero_data.png"
        );

        const item = {
            imagePath: imagePath,
            primaryText: Resources.ZeroDataPrimaryText_NoIntegrationsConfigured,
            imageAltText: Resources.ZeroDataAltText_NoIntegrationsConfigured,
            secondaryText: this._renderSecondary()
        } as IZeroDataItem;
        return (
            <div className="no-outline" ref={this._onRef} role="presentation">
                <div className={"zero-data flex-row justify-center repository-pivot"}>
                    <ZeroDataItem item={item} />
                </div>
            </div>
        );
    }

    private readonly _renderSecondary = (): JSX.Element => {
        return (
            <>
                <div>
                    <Link target="_blank" href={DocUrls.GitHubAndAzureBoards_Portal}>
                        {Resources.ZeroDataSecondaryText_NoIntegrationsConfigured1}
                    </Link>
                    <span>{Resources.ZeroDataSecondaryText_NoIntegrationsConfigured2}</span>
                </div>
                {this._renderPermissionText()}
                {this._renderNewConnection()}
            </>
        );
    };

    private readonly _renderPermissionText = (): JSX.Element | null => {
        return !this.props.hasWritePermission ? (
            <>
                <br />
                <br />
                <span>{Resources.ZeroDataPageNoPermissionTextFirstLine}</span>
            </>
        ) : null;
    };

    private readonly _renderNewConnection = (): JSX.Element | null => {
        if (this.props.hasWritePermission) {
            return isHosted(this.context.pageContext) ? this._renderHostedNewConnection() : this._renderEnterpriseNewConnection();
        }

        return null;
    };

    private readonly _renderHostedNewConnection = (): JSX.Element => {
        return (
            <>
                <NewConnection
                    showPanel={this.props.showPanel}
                    onConnectButtonClick={this.props.onConnectButtonClick}
                    onOAuthError={this.props.onOAuthError}
                    disableOAuth={isIE()}
                />
            </>
        );
    };

    private readonly _renderEnterpriseNewConnection = (): JSX.Element => {
        return <EnterpriseNewConnection showPanel={this.props.showPanel} disableOAuth={isIE()} />;
    };

    private readonly _onRef = (ref: HTMLDivElement | null) => {
        // auto focus on mount so the narrator reads the help text
        if (ref) {
            ref.focus();
        }
    };
}
